import { h, Component } from 'preact';
import { riperStorage } from '@/base/helpers';
import { getDataProductButton } from '../utils';
import './ProductButton.css';

export default class ProductButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      account: props.account,
      coupon: props.coupon,
      status: '',
      message: '',
      product: {},
      variantID: null,
      variantPrice: null,
    };
  }

  componentDidMount() {
    this.setState((prevState) => ({
      ...prevState,
      account: riperStorage.account,
      coupon: riperStorage.coupon,
    }));

    // (The "domElem" elem is assigned in the render function.)
    this.domElem.addEventListener('event:liana:redemption', this.handleProductRedemption);
  }

  componentWillUnmount() {
    this.domElem.removeEventListener('event:liana:redemption', this.handleProductRedemption);
  }

  handleProductRedemption = (event) => {
    this.setState(event.detail);
  };

  render() {
    const { display, buttonParams, buttonClass, onAbout } = this.props;
    const { productID, variantID, variantPrice } = buttonParams;
    const { account, coupon, status, message } = this.state;
    const {
      style: { primary_color: primaryColor, contrast_color: contrastColor },
    } = display;
    const { buttonText, handleClick } = getDataProductButton(
      display,
      account,
      coupon,
      productID,
      variantID,
      variantPrice,
      onAbout,
      status,
      message
    );

    return (
      <div ref={(elem) => (this.domElem = elem)}>
        <div
          onClick={handleClick}
          style={{ background: `${primaryColor}`, color: `${contrastColor}` }}
          className={buttonClass || 'bns-product-button'}
        >
          {buttonText}
        </div>
      </div>
    );
  }
}
